import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHash = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.33334 2L4.33334 14M11.6667 2L9.66666 14M13.6667 5.33333H2.33335M13 10.6667H1.66669",
		stroke: "#ADB5BD",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHash;
